import _ from 'underscore';
import { addColumnOnLevel } from '../add-column-on-level';
import dayOfWeekTemplate from './dayofweek-template.pug';
import dateTemplate from './date-template.pug';
import weekTemplate from './week-template.pug';
import monthTemplate from './month-template.pug';
import quarterTemplate from './quarter-template.pug';
import yearTemplate from './year-template.pug';
import { Constants } from '../constants';
import { absoluteTopImpressionRate, topImpressionRate } from '../shared/columns';

export function getTimeGridColumnConfig({
  i18n,
  bingadsGridColumn,
  globalConfig,
  getCurrentLevel,
}) {
  const {
    IsViewThroughConversionEnabled,
    IsAvgPositionDeprecationPhase2Enabled,
    IsManualCpmEnabled,
    dynamic = {},
    // IsViewThroughConversionsRevenueEnabled,
  } = globalConfig.get('Permissions') || {};
  // (youngim) MT bug needs to be fixed for dimensinos
  const IsViewThroughConversionsRevenueEnabled = false;

  const {
    PartialConversions: IsPartialConversionsEnabled,
    ColumnConversion: IsColumnConversionEnabled,
  } = dynamic;

  const usePartialConversions = IsPartialConversionsEnabled && IsColumnConversionEnabled;

  function column(options) {
    return bingadsGridColumn(_.defaults({}, options, { i18n }));
  }

  return {
    getGridSpecificColumns: (gridType) => {
      const columns = [];

      switch (gridType) {
        case Constants.TimeHour:
          columns.push(column({
            name: 'HourOfDay',
            title: 'ColumnName_HourOfDay',
            sortable: true,
            type: 'string',
            helpId: 'Pop_BA_DimensionGrid_HourOfDay',
          }));
          break;
        case Constants.TimeDay:
          columns.push(column({
            name: 'DayOfWeek',
            title: 'ColumnName_DayOfWeek',
            property: {
              get(row) {
                let dayOfWeek = null;

                switch (row.DayOfWeek) {
                  case 1:
                    dayOfWeek = i18n.getString('Dimension_WeekDay_1');
                    break;
                  case 2:
                    dayOfWeek = i18n.getString('Dimension_WeekDay_2');
                    break;
                  case 3:
                    dayOfWeek = i18n.getString('Dimension_WeekDay_3');
                    break;
                  case 4:
                    dayOfWeek = i18n.getString('Dimension_WeekDay_4');
                    break;
                  case 5:
                    dayOfWeek = i18n.getString('Dimension_WeekDay_5');
                    break;
                  case 6:
                    dayOfWeek = i18n.getString('Dimension_WeekDay_6');
                    break;
                  case 7:
                    dayOfWeek = i18n.getString('Dimension_WeekDay_7');
                    break;
                  default:
                    break;
                }

                return {
                  dayOfWeek,
                };
              },
              key: 'DayOfWeek',
            },
            template: dayOfWeekTemplate,
            sortable: true,
            type: 'string',
            helpId: 'Pop_BA_DimensionGrid_DayOfWeek',
          }));
          break;
        case Constants.TimeDate:
          columns.push(column({
            name: 'GregorianDate',
            title: 'ColumnName_Date',
            property: {
              get(row) {
                return {
                  date: (new Date(row.GregorianDate)).toDateString(),
                };
              },
              key: 'GregorianDate',
            },
            template: dateTemplate,
            sortable: true,
            type: 'string',
            helpId: 'Pop_BA_DimensionGrid_Date',
          }));
          break;
        case Constants.TimeWeek:
          columns.push(column({
            name: 'Week',
            title: 'ColumnName_Week',
            sortable: true,
            property: {
              get(row) {
                const dt = new Date(row.Week);

                return {
                  i18nStr: i18n.getString('Dimension_Week_Text'),
                  week: `${(dt.getMonth() + 1)}/${dt.getDate()}/${(dt.getYear() + 1900)}`,
                };
              },
              key: 'Week',
            },
            template: weekTemplate,
            type: 'string',
            helpId: 'Pop_BA_DimensionGrid_Week',
          }));

          break;
        case Constants.TimeMonth:
          columns.push(column({
            name: 'Month',
            title: 'ColumnName_Month',
            sortable: true,
            property: {
              get(row) {
                const dt = new Date(row.Month);
                let month = dt.getMonth();

                switch (month) {
                  case 0:
                    month = i18n.getString('Dimension_Month_Jan');
                    break;
                  case 1:
                    month = i18n.getString('Dimension_Month_Feb');
                    break;
                  case 2:
                    month = i18n.getString('Dimension_Month_Mar');
                    break;
                  case 3:
                    month = i18n.getString('Dimension_Month_Apr');
                    break;
                  case 4:
                    month = i18n.getString('Dimension_Month_May');
                    break;
                  case 5:
                    month = i18n.getString('Dimension_Month_Jun');
                    break;
                  case 6:
                    month = i18n.getString('Dimension_Month_Jul');
                    break;
                  case 7:
                    month = i18n.getString('Dimension_Month_Aug');
                    break;
                  case 8:
                    month = i18n.getString('Dimension_Month_Sep');
                    break;
                  case 9:
                    month = i18n.getString('Dimension_Month_Oct');
                    break;
                  case 10:
                    month = i18n.getString('Dimension_Month_Nov');
                    break;
                  case 11:
                    month = i18n.getString('Dimension_Month_Dec');
                    break;
                  default:
                    break;
                }

                return {
                  month: `${month} ${(dt.getYear() + 1900)}`,
                };
              },
              key: 'Month',
            },
            template: monthTemplate,
            type: 'string',
            helpId: 'Pop_BA_DimensionGrid_Month',
          }));
          break;
        case Constants.TimeQuarter:
          columns.push(column({
            name: 'Quarter',
            title: 'ColumnName_Quarter',
            sortable: true,
            property: {
              get(row) {
                const dt = new Date(row.Quarter);
                const month = dt.getMonth();
                const quarter = Math.ceil((month + 1) / 3);

                return {
                  quarter: `Q${quarter} ${(dt.getYear() + 1900)}`,
                };
              },
              key: ['Quarter'],
            },
            template: quarterTemplate,
            type: 'string',
            helpId: 'Pop_BA_DimensionGrid_Quarter',
          }));
          break;
        case Constants.TimeYear:
          columns.push(column({
            name: 'Year',
            title: 'Dimension_ColumnName_Year',
            sortable: true,
            property: {
              get(row) {
                return {
                  year: row.Year,
                };
              },
              key: 'Year',
            },
            template: yearTemplate,
            type: 'string',
            helpId: 'Pop_BA_DimensionGrid_Year',
          }));
          break;
        default:
          break;
      }
      return columns;
    },
    getLevelOfDetailColumns: () => {
      const levelOfDetailColumns = [];

      addColumnOnLevel(column, levelOfDetailColumns, getCurrentLevel());

      return levelOfDetailColumns;
      // TODO [kyyook]: These columns are commented as they are not supported in phase 1.
      // To be enabled in Phase 2 of Dimension project
      /*
        column({
          name: 'AdgroupStatus',
          title: 'ColumnName_AdgroupStatus',
          sortable: true,
          type: 'string',
          helpId: 'Pop_BA_DimensionGrid_AdgroupStatus',
        }),
        column({
          name: 'CampaignStatus',
          title: 'ColumnName_CampaignStatus',
          sortable: true,
          type: 'string',
          helpId: 'Pop_BA_DimensionGrid_CampaignStatusStatus',
        }),
        */
    },
    getPerfColumns: () => {
      let perfColumns = [
        column({
          name: 'Impressions',
          title: 'ColumnName_Impressions',
          sortable: true,
          type: 'number',
          format: 'integer',
          helpId: 'Page_CampaignGrids_Impr',
        }),
        column({
          name: 'Clicks',
          title: 'ColumnName_Clicks',
          sortable: true,
          type: 'number',
          format: 'integer',
          helpId: 'Page_CampaignGrids_Clicks',
        }),
        column({
          name: 'CTR',
          title: 'ColumnName_ClickThruRate',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'Page_CampaignGrids_CTR',
        }),
        column({
          name: 'AverageCPC',
          title: 'ColumnName_AverageCPC',
          sortable: true,
          type: 'number',
          helpId: 'Page_CampaignGrids_AvgCPC',
        }),
        IsManualCpmEnabled && column({
          name: 'AverageCPM',
          title: 'ColumnName_AverageCPM',
          sortable: true,
          type: 'number',
          helpId: 'pop_BA_CampaignGrids_AvgCPM',
        }),
        column({
          name: 'Spend',
          title: 'ColumnName_Spend',
          sortable: true,
          type: 'number',
          helpId: 'Page_CampaignGrids_Spend',
        }),
        column(topImpressionRate),
        column(absoluteTopImpressionRate),
      ];

      if (!IsAvgPositionDeprecationPhase2Enabled) {
        perfColumns = perfColumns.concat([
          column({
            name: 'AveragePosition',
            title: 'ColumnName_AveragePosition',
            sortable: true,
            type: 'number',
            helpId: 'Page_CampaignGrids_AvgPosition',
          }),
        ]);
      }

      return _.compact(perfColumns);
    },
    getConversionColumns: () => {
      let conversionColumns = [
        usePartialConversions ?
          column({
            name: 'ConversionsCredit',
            title: 'ColumnName_Conversions',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'Page_CampaignGrids_Conv',
          }) : column({
            name: 'Conversions',
            title: 'ColumnName_Conversions',
            sortable: true,
            type: 'number',
            format: 'integer',
            helpId: 'Page_CampaignGrids_Conv',
          }),
        usePartialConversions ?
          column({
            name: 'PartialConversionRate',
            title: 'ColumnName_ConversionRate',
            sortable: true,
            type: 'number',
            format: 'percentage-value',
            helpId: 'Page_CampaignGrids_ConvRate',
          }) : column({
            name: 'ConversionRate',
            title: 'ColumnName_ConversionRate',
            sortable: true,
            type: 'number',
            format: 'percentage-value',
            helpId: 'Page_CampaignGrids_ConvRate',
          }),
        usePartialConversions ?
          column({
            name: 'PartialConversionCPA',
            title: 'ColumnName_CPA',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'Page_CampaignGrids_CPA',
          }) : column({
            name: 'CPA',
            title: 'ColumnName_CPA',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'Page_CampaignGrids_CPA',
          }),
        // TODO [kyyook]: These columns are commented as they are not supported in phase 1.
        // To be enabled in Phase 2 of Dimension project
        /*
        column({
          name: 'Assists',
          title: 'ColumnName_Assists',
          sortable: true,
          type: 'number',
          helpId: 'Page_Reporting_Clarity_Assists',
        }),
        column({
          name: 'ExtendedCost',
          title: 'ColumnName_ExtendedCost',
          sortable: true,
          type: 'number',
          helpId: 'Pop_BA_DimensionGrid_ExtendedCost',
        }),
        column({
          name: 'RevenueConversion',
          title: 'ColumnName_RevenueConversion',
          sortable: true,
          type: 'number',
          helpId: 'pop_BA_Reporting_Clarity_RevenueConversion',
        }),
        column({
          name: 'RevenuePerAssist',
          title: 'ColumnName_RevenuePerAssist',
          sortable: true,
          type: 'number',
          helpId: 'pop_BA_Reporting_Clarity_RevenueAssist',
        }),
        */
        column({
          name: 'RevenueOnAdSpend',
          title: 'ColumnName_RevenueOnAdSpend',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'Page_CampaignGrids_ReturnAdSpend',
        }),
        column({
          name: 'AdvertiserReportedRevenue',
          title: 'ColumnName_Revenue',
          sortable: true,
          type: 'number',
          helpId: 'Page_CampaignGrids_Revenue',
        }),
        usePartialConversions ?
          column({
            name: 'AllConversionsCredit',
            title: 'ColumnName_AllConversions',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'pop_BA_CampaignGrids_AllConv',
          }) : column({
            name: 'AllConversions',
            title: 'ColumnName_AllConversions',
            sortable: true,
            type: 'number',
            format: 'integer',
            helpId: 'pop_BA_CampaignGrids_AllConv',
          }),
        usePartialConversions ?
          column({
            name: 'AllPartialConversionCPA',
            title: 'ColumnName_AllConversionCPA',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'pop_BA_CampaignGrids_AllConvCPA',
          }) :
          column({
            name: 'AllConversionCPA',
            title: 'ColumnName_AllConversionCPA',
            sortable: true,
            type: 'number',
            format: 'decimal',
            helpId: 'pop_BA_CampaignGrids_AllConvCPA',
          }),
        usePartialConversions ? column({
          name: 'AllPartialConversionRate',
          title: 'ColumnName_AllConversionRate',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_CampaignGrids_AllConvRate',
        }) :
          column({
            name: 'AllConversionRate',
            title: 'ColumnName_AllConversionRate',
            sortable: true,
            type: 'number',
            format: 'percentage-value',
            helpId: 'pop_BA_CampaignGrids_AllConvRate',
          }),
        column({
          name: 'AllConversionAdvertiserReportedRevenue',
          title: 'ColumnName_AllConversionAdvertiserReportedRevenue',
          sortable: true,
          type: 'number',
          helpId: 'pop_BA_CampaignGrids_AllConvRevenue',
        }),
        column({
          name: 'AllConversionRevenueOnAdSpend',
          title: 'ColumnName_AllConversionRevenueOnAdSpend',
          sortable: true,
          type: 'number',
          helpId: 'pop_BA_CampaignGrids_AllConvROAS',
        }),
      ];

      if (IsViewThroughConversionEnabled) {
        conversionColumns = conversionColumns.concat([
          usePartialConversions ?
            column({
              name: 'ViewThroughConversionsCredit',
              title: 'ColumnName_ViewThroughConversions',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_CampaignGrids_ViewThrough',
              format: 'decimal',
            }) :
            column({
              name: 'ViewThroughConversions',
              title: 'ColumnName_ViewThroughConversions',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_CampaignGrids_ViewThrough',
              format: 'integer',
            }),
        ]);
      }

      if (IsViewThroughConversionsRevenueEnabled) {
        conversionColumns = conversionColumns.concat([
          column({
            name: 'ViewThroughConversionsRevenue',
            title: 'ColumnName_ViewThroughConversionsRevenue',
            sortable: true,
            type: 'number',
            helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvRevenue',
            format: 'decimal',
          }),
          usePartialConversions ?
            column({
              name: 'ViewThroughPartialConversionsCPA',
              title: 'ColumnName_ViewThroughConversionsCPA',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvCPA',
              format: 'decimal',
            }) :
            column({
              name: 'ViewThroughConversionsCPA',
              title: 'ColumnName_ViewThroughConversionsCPA',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvCPA',
              format: 'decimal',
            }),
          column({
            name: 'ViewThroughConversionsReturnOnAdSpend',
            title: 'ColumnName_ViewThroughConversionsReturnOnAdSpend',
            sortable: true,
            type: 'number',
            helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvReturnOnAdSpend',
            format: 'percentage-value',
          }),
          usePartialConversions ?
            column({
              name: 'ViewThroughPartialConversionsRate',
              title: 'ColumnName_ViewThroughConversionsRate',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvRate',
              format: 'percentage-value',
            }) :
            column({
              name: 'ViewThroughConversionsRate',
              title: 'ColumnName_ViewThroughConversionsRate',
              sortable: true,
              type: 'number',
              helpId: 'pop_BA_Reporting_Clarity_ViewThroughConvRate',
              format: 'percentage-value',
            }),
        ]);
      }

      return conversionColumns;
    },
    getCompetitiveColumns: () => {
      const competitiveColumns = [
        column({
          name: 'AuctionWonPercent',
          title: 'ColumnName_ImpShare',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'Page_Reporting_Clarity_ImpressionShare',
        }),
        column({
          name: 'AuctionLostToBudgetPercent',
          title: 'ColumnName_ImpShareLostToBudget',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_Reporting_Clarity_ImpShrLostBudget',
        }),
        column({
          name: 'AuctionLostToRankAggPercent',
          title: 'ColumnName_ImpShareLostToRank',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_Reporting_Clarity_ImpShrLostRank',
        }),
        column({
          name: 'TopImpressionSharePercent',
          title: 'ColumnName_TopImpressionSharePercent',
          property: 'TopImpressionSharePercent',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_Reporting_Clarity_TopImpressionShare',
        }),
        column({
          name: 'TopImpressionShareLostToBudgetPercent',
          title: 'ColumnName_TopImpressionShareLostToBudget',
          property: 'TopImpressionShareLostToBudgetPercent',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_Reporting_Clarity_TopImpressionLosttoBudget',
        }),
        column({
          name: 'TopImpressionShareLostToRankPercent',
          title: 'ColumnName_TopImpressionShareLostToRank',
          property: 'TopImpressionShareLostToRankPercent',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_Reporting_Clarity_TopImpressionLosttoRank',
        }),
        column({
          name: 'AbsoluteTopImpressionSharePercent',
          title: 'ColumnName_AbsoluteTopImpressionSharePercent',
          property: 'AbsoluteTopImpressionSharePercent',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_Reporting_ProductAds_AbsoluteTopImpShare',
        }),
        column({
          name: 'AbsoluteTopImpressionShareLostToBudgetPercent',
          title: 'ColumnName_AbsoluteTopImpressionShareLostToBudget',
          property: 'AbsoluteTopImpressionShareLostToBudgetPercent',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_Reporting_Clarity_AbsoluteTopISLosttoBudget',
        }),
        column({
          name: 'AbsoluteTopImpressionShareLostToRankPercent',
          title: 'ColumnName_AbsoluteTopImpressionShareLostToRank',
          property: 'AbsoluteTopImpressionShareLostToRankPercent',
          sortable: true,
          type: 'number',
          format: 'percentage-value',
          helpId: 'pop_BA_Reporting_Clarity_AbsoluteTopISLosttoRank',
        }),
      ];

      return competitiveColumns;
    },
  };
}
